import CharacterRoleIcon from 'app/frontend/base/components/CharacterRoleIcon'
import { Link } from 'react-router-dom'
import { RosterSetupContext } from '../../../../TeamRoster/components/RosterSetup'
import { useContext } from 'react'
import { CharacterClassIcon } from 'app/frontend/base/components'
import { characterRoles } from 'app/frontend/types/custom/CharacterRole'
import Card from 'app/frontend/base/components/Card'

const FullList = () => {
  const { mainsByRole } = useContext(RosterSetupContext)

  return (
    <div className='space-y-4'>
      {characterRoles.map((role) => {
        const mains = (mainsByRole[role] ?? []).sort((a, b) => {
          return a.characterReference.name.localeCompare(
            b.characterReference.name,
          )
        })

        return (
          <div key={role} className='space-y-1'>
            {mains.map((main) => {
              return (
                <Card
                  key={main.id}
                  className='flex items-center justify-between gap-2 py-1 px-2'
                >
                  <CharacterRoleIcon role={role} size='small' />
                  <CharacterClassIcon
                    characterClass={main.characterReference.characterClass}
                    size='small'
                    style='round'
                  />
                  <div className='grow'>
                    <Link to={main.characterReference.path}>
                      {main.characterReference.name}
                    </Link>
                  </div>
                </Card>
              )
            })}
          </div>
        )
      })}
    </div>
  )
}

export default FullList
